
import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

import AcademicPlannerPDF from "../assets/pdf/Academic-Planner.pdf";
import ActivityList from "../assets/pdf/Activity-List.pdf";
import TCForm from "../assets/pdf/tc-form.pdf";
import MemberList from "../assets/pdf/SMC-MEMBER-LIST-2026-27.pdf";

function Footer() {
  return (
    <footer className="school-footer">
      <div className="container">

        <div className="row footer-main gy-5">

          {/* COLUMN 1 - SCHOOL IDENTITY */}
          <div className="col-lg-3 col-md-6">
            <div className="footer-brand">

              <h3>
                AIR FORCE SCHOOL
                <span>VAYU SENA NAGAR, NAGPUR</span>
              </h3>

              <div className="footer-brand-line"></div>

              <p>
                Established in 1968, Air Force School is dedicated
                to providing quality education and nurturing
                confident, responsible and disciplined learners.
              </p>

              <div className="footer-social">
                <a
                  href="https://www.facebook.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <i className="bi bi-facebook"></i>
                </a>

                <a
                  href="https://www.instagram.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <i className="bi bi-instagram"></i>
                </a>

                <a
                  href="https://www.youtube.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                >
                  <i className="bi bi-youtube"></i>
                </a>
              </div>

            </div>
          </div>

          {/* COLUMN 2 - ABOUT SCHOOL */}
          <div className="col-lg-2 col-md-6">
            <h5 className="footer-heading">About School</h5>

            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/history">Our History</Link></li>
              <li><Link to="/infrastructure">Infrastructure</Link></li>
              <li><Link to="/school-management">School Management</Link></li>
              <li><Link to="/teacher-list">Teacher List</Link></li>
            </ul>
          </div>

          {/* COLUMN 3 - ACADEMICS & DOWNLOADS */}
          <div className="col-lg-3 col-md-6">
            <h5 className="footer-heading">Academics & Downloads</h5>

            <ul className="footer-links">
              <li><Link to="/courses">Courses</Link></li>

              <li>
                <a href={AcademicPlannerPDF}
                  target="_blank"
                  rel="noopener noreferrer">
                  Academic Planner
                </a>
              </li>

              <li><Link to="/admission-form">Admission Form</Link></li>

              <li>
                <a href={TCForm}
                  target="_blank"
                  rel="noopener noreferrer">
                  Transfer Certificate Form
                </a>
              </li>

              <li>
                <a href={ActivityList}
                  target="_blank"
                  rel="noopener noreferrer">
                  Activity List
                </a>
              </li>

              <li>
                <a href={MemberList}
                  target="_blank"
                  rel="noopener noreferrer">
                  SMC Member List
                </a>
              </li>
            </ul>
          </div>

          {/* COLUMN 4 - CONTACT */}
          <div className="col-lg-4 col-md-6">
            <h5 className="footer-heading">Get In Touch</h5>

            <p className="footer-contact-intro">
              We welcome your enquiries. Get in touch with the
              school office for further information.
            </p>

            <div className="footer-contact-item">
              <div className="footer-contact-icon">
                <i className="bi bi-geo-alt-fill"></i>
              </div>
              <div>
                <h6>Our Address</h6>
                <p>Vayu Sena Nagar, Nagpur, Maharashtra, India</p>
              </div>
            </div>

            <div className="footer-contact-item">
              <div className="footer-contact-icon">
                <i className="bi bi-telephone-fill"></i>
              </div>
              <div>
                <h6>Phone Number</h6>
                <p>
                  <a href="tel:07122511407">0712-2511407</a>
                </p>
              </div>
            </div>

            <div className="footer-contact-item">
              <div className="footer-contact-icon">
                <i className="bi bi-phone-fill"></i>
              </div>
              <div>
                <h6>Mobile Number</h6>
                <p>
                  <a href="tel:9146071487">9146071487</a>
                </p>
              </div>
            </div>

          </div>

        </div>

        {/* FOOTER BOTTOM */}
        <div className="footer-bottom">
          <p>
            © {new Date().getFullYear()} Air Force School,
            Vayu Sena Nagar, Nagpur. All Rights Reserved.
          </p>
        </div>

      </div>
    </footer>
  );
}

export default Footer;
